import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ap-basic-layout',
  templateUrl: './basic-layout.component.html',
  encapsulation: ViewEncapsulation.None
})
export class BasicLayoutComponent { }
